import React, { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import nextArrow from '../../assets/nextArrow.png'

import BackArrow from "../../assets/backArrow.png"
import { useParams } from 'react-router-dom';
  import {  IconButton} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import {
  Box,
  Card,
  CardContent,
  CardMedia,
  Typography,
  Button,
  Divider,
  Paper,
  Tooltip ,
  Stack
} from "@mui/material";
import logger from "../../Utils/logger";

function OrderDeatails(props) {
  //logger.log("props Orders",props.orderdetail.vendingMachineAddress)
  const UserJWTAuth = localStorage.getItem('UserJWTAuth');
  const navigate=useNavigate()
  const orderId = useParams();
  //logger.log("orderId",orderId.orderId)





  const helpFun=(e,order_id)=>{
   logger.log("order_id",order_id)
   navigate(`/ordersearch?id=${order_id}`)

  }
const handleBack=()=>{
  navigate(`/orders`)
}

// --- Helper: Truncate Long Text ---


// --- Helper: Truncated text with tooltip ---
const TruncatedText = ({ text = "", limit = 30, style = {} }) => {
  const truncated = text.length > limit ? text.slice(0, limit) + "…" : text;
  return (
    <Tooltip title={text} disableHoverListener={text.length <= limit}>
      <Typography
        sx={{
          fontSize: "13px",
          color: "#583C43",
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "200px",
          ...style,
        }}
      >
        {truncated}
      </Typography>
    </Tooltip>
  );
};

// --- Main TopNav ---
const TopNav = () => {
  return (
    <Box
      sx={{
        background: "#fae14b",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        zIndex: 999,
        p: 1.5,
        boxShadow: "0 1px 4px rgba(0,0,0,0.1)",
      }}
    >
      {/* Header Row */}
      <Stack direction="row" alignItems="center" spacing={1}>
        <IconButton size="small" onClick={handleBack}>
          <ArrowBackIcon />
        </IconButton>

        <Box>
          <Typography
            sx={{
              fontWeight: 600,
              color: "#583C43",
              fontSize: "14px",
              lineHeight: 1.2,
            }}
          >
            VM_ID={props?.orderdetail?.vendingMachineId || "N/A"}
          </Typography>

          <TruncatedText
            text={props?.orderdetail?.vendingMachineAddress || "Unknown Address"}
            limit={30}
          />
        </Box>
      </Stack>

      {/* Order Info Row */}
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mt={1}
        px={1}
      >
        <Typography sx={{ fontSize: "12px", color: "#583C43" }}>
          Order ID: #{props?.orderdetail?.orderId || "N/A"}
        </Typography>
        <Typography sx={{ fontSize: "12px", color: "#583C43" }}>
          {new Date(props?.orderdetail?.createdAt).toLocaleString("en-IN", {
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
          })}
        </Typography>
      </Stack>
    </Box>
  );
};







const OrderSummary = () => {
  const lineItems = props?.orderdetail?.lineItems || [];

  return (
    <Box sx={{ px: 2, py: 1 }}>
      {/* Product List */}
      {lineItems.map((el, index) => (
        <Card
          key={index}
          elevation={3}
          sx={{
            mb: 2,
            borderRadius: 2,
            overflow: "hidden",
            display: "flex",
            alignItems: "center",
            px: 1.5,
            py: 1.2,
          }}

         onClick={() => {
  if (el.isDigital==true) {
    navigate(`/digital?value=${props?.orderdetail?.orderId}`);
  } else {
    logger.log("Invalid item");
  }
}}
        >
          {/* Product Image */}
          <CardMedia
            component="img"
            src={`https://daalchini.s3.ap-south-1.amazonaws.com/dcprod/${el.imageUrl}`}
            alt={el.productName}
            sx={{
              width: 80,
              height: 80,
              borderRadius: 2,
              backgroundColor: "#FBEDD7",
              mr: 2,
              objectFit: "cover",
            }}
          />

          {/* Product Details */}
          <CardContent sx={{ flex: 1, p: 0 }} style={{padding:"0"}}>
            <Typography
              variant="subtitle1"
              sx={{ color: "#384F6F", fontWeight: 600 }}
            >
              {el.productName}
            </Typography>

            <Typography
              variant="body2"
              sx={{ color: "#718198", mt: 0.5, fontSize: "13px" }}
            >
              {el.unitCount} Item{el.unitCount > 1 ? "s" : ""}
            </Typography>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                mt: 1,
              }}
            >
              <Typography
                variant="body2"
                sx={{ color: "#00B177", fontWeight: 600, fontSize: "13px" }}
              >
                ₹ {el.offerPrice.toFixed(2)}
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  color: "#00B177",
                  fontWeight: 600,
                  fontSize: "13px",
                  mr: 2,
                }}
              >
                {props?.orderdetail?.status}
              </Typography>
            </Box>
          </CardContent>
        </Card>
      ))}

      {/* Grand Total Section */}
      <Paper
        elevation={2}
        sx={{
          borderRadius: 2,
          px: 2,
          py: 1,
          mb: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography variant="subtitle2" sx={{ color: "#384F6F" }}>
          Grand Total
        </Typography>
       
     <Typography variant="subtitle2" sx={{ color: "#384F6F" }}>
  ₹ {props?.totalAmount ? Number(props.totalAmount).toFixed(2) : "0.00"}
</Typography>
      </Paper>

      {/* Help & Support */}
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 3,
          mb: 1,
        }}
      >
        <Button
          variant="outlined"
          sx={{
            borderColor: "rgb(113, 129, 152)",
            color: "#718198",
            borderRadius: "8px",
            textTransform: "none",
            px: 3,
            py: 0.8,
            fontSize: "14px",
          }}
          onClick={(e) => helpFun(e, orderId.orderId)}
        >
          Help & Support
        </Button>
      </Box>
    </Box>
  );
};



  return (
 
      
    <div /* id="root" */ style={{ height: "100%" }}>
    <div className="_2yoTv ns7Wo">
   
       <TopNav/> 
       <div style={{marginTop:"100px"}}>
    <OrderSummary/>
      </div>
    </div>
  </div>
  )
 


}

export default OrderDeatails;
